import React, { useContext } from 'react'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer"

export default function Step(props) {
  const { isAccessoryShop } = useContext(ConfiguratorContext)

  const onClick = function () {
    if (props.step_is_valid === 'true') {
      props.onClick(props.step.step_id)
    }
  }

  return (
    <aside
      className='step'
      onClick={onClick}
      active={props.active.toString()}
      step_is_valid={props.step_is_valid.toString()}
      id={'step-' + props.step.step_id}
    >
      {isAccessoryShop ? null : <span>{props.index}.</span>}
      {props.step.title}
    </aside>
  )
}

Step.defaultProps = {
  step_is_valid: 'false'
}
